import React from 'react';
import styled from 'styled-components';

import {
  CellGridVolumeModel,
  cutColorBarPalette,
  fillColorBarPalette,
} from '../../../../../viewer/elements/volume/model/cell-grid-volume-model';
import { VolumeCalculationAsset } from '../../../../../viewer/elements/volume/types';
import { Stack } from '../../../stack/stack';
import { ColorBarSection } from './color-bar-section';

type Props = {
  asset: VolumeCalculationAsset;
  cut: {
    value: number;
    isDefaultValue: boolean;
  };
  fill: {
    value: number;
    isDefaultValue: boolean;
  };
};

const ColorBar = (props: Props) => {
  const volumeHandler = props.asset.volumeHandler;
  const volumeModel = volumeHandler.volumeModel as CellGridVolumeModel;

  const heightMax =
    volumeModel.cut_opacity_threshold_table[3] > volumeModel.max ? 'Max' : volumeModel.max;

  const heightMin =
    volumeModel.fill_opacity_threshold_table[3] < volumeModel.min ? 'Min' : volumeModel.min;

  const displaySingleCutSection = !props.cut.isDefaultValue && props.cut.value === 0;
  const displaySingleFillSection = !props.fill.isDefaultValue && props.fill.value === 0;

  //
  // Make each section 9% height of available height.
  // 10 sections => total height of 95%, to not fill the entire space.
  //
  return (
    <Component direction="column" spacing={0}>
      <ColorBarSection
        height={heightMax}
        surface={{
          color: cutColorBarPalette[4],
          height: displaySingleCutSection ? '45%' : '9%',
          planeArea: volumeModel.planarAreaCut[4],
        }}
      />
      {!displaySingleCutSection && (
        <>
          <ColorBarSection
            height={volumeModel.cut_opacity_threshold_table[3]}
            surface={{
              color: cutColorBarPalette[3],
              planeArea: volumeModel.planarAreaCut[3],
              height: '9%',
            }}
          />
          <ColorBarSection
            height={volumeModel.cut_opacity_threshold_table[2]}
            surface={{
              color: cutColorBarPalette[2],
              planeArea: volumeModel.planarAreaCut[2],
              height: '9%',
            }}
          />
          <ColorBarSection
            height={volumeModel.cut_opacity_threshold_table[1]}
            surface={{
              color: cutColorBarPalette[1],
              planeArea: volumeModel.planarAreaCut[1],
              height: '9%',
            }}
          />
          <ColorBarSection
            height={volumeModel.cut_opacity_threshold_table[0]}
            surface={{
              color: cutColorBarPalette[0],
              planeArea: volumeModel.planarAreaCut[0],
              height: '9%',
            }}
          />
        </>
      )}
      {!displaySingleFillSection && (
        <>
          <ColorBarSection
            height={0}
            surface={{
              color: fillColorBarPalette[0],
              planeArea: volumeModel.planarAreaFill[0],
              height: '9%',
            }}
          />
          <ColorBarSection
            height={volumeModel.fill_opacity_threshold_table[0]}
            surface={{
              color: fillColorBarPalette[1],
              planeArea: volumeModel.planarAreaFill[1],
              height: '9%',
            }}
          />
          <ColorBarSection
            height={volumeModel.fill_opacity_threshold_table[1]}
            surface={{
              color: fillColorBarPalette[2],
              planeArea: volumeModel.planarAreaFill[2],
              height: '9%',
            }}
          />
          <ColorBarSection
            height={volumeModel.fill_opacity_threshold_table[2]}
            surface={{
              color: fillColorBarPalette[3],
              planeArea: volumeModel.planarAreaFill[3],
              height: '9%',
            }}
          />
        </>
      )}
      <ColorBarSection
        height={volumeModel.fill_opacity_threshold_table[3]}
        surface={{
          color: fillColorBarPalette[4],
          planeArea: volumeModel.planarAreaFill[4],
          height: displaySingleFillSection ? '45%' : '9%',
        }}
      />
      <ColorBarSection height={heightMin} />
    </Component>
  );
};

const Component = styled(Stack)`
  margin-top: 0.5em;
  height: 100%;
`;

export { ColorBar };
